<template>
    <div>
        <h2 class="text-body font-semibold mb-16">{{ placeholder }}</h2>
        <div class="flex items-center pb-20 mb-16 border-b-2 border-primary-5">
            <simple-input
                ref="input"
                v-model="newTemplate"
                class="flex flex-grow mr-auto min-w-320"
                :placeholder="placeholder"
                @enter="createTemplate"
            >
                <template #after>
                    <button
                        class="flex items-center gap-8"
                        :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
                        :disabled="disabled"
                        @click="createTemplate"
                    >
                        <loading v-if="creatingTemplate" type="spinner" size="small"/>
                        <svg-icon v-else type="add-circle" />
                        {{ $t('general.add') }}
                    </button>
                </template>
            </simple-input>
        </div>
    </div>
</template>

<script>
import Input from "../forms/Input";
import SvgIcon from "../ui/SvgIcon";
import {normalizeJson} from "../../../shared/helpers";
import SimpleButton from "../ui/SimpleButton";
import Loading from "../ui/Loading.vue";
import CompetenceTemplate from "../../models/CompetenceTemplate";
import InterviewTemplate from "../../models/InterviewTemplate";
import {useRepo} from "pinia-orm";
import {mapState} from "pinia";
import {useMainStore} from "../../state/store";
import FilterGroup from "../../models/FilterGroup";

export default {
    components: {
        Loading,
        'simple-input': Input,
        SimpleButton,
        SvgIcon,
    },
    props: {
        service: null,
        template: null,
    },
    data: function () {
        return {
            creatingTemplate: false,
            newTemplate: '',
            models: {
                'competence-templates': CompetenceTemplate,
                'interview-templates': InterviewTemplate,
                'filter-groups': FilterGroup,
            }
        }
    },
    computed: {
        ...mapState(useMainStore, ['templateModuleInfo']),
        moduleInfo() {
            return this.templateModuleInfo;
        },
        model() {
            return useRepo(this.models[this.moduleInfo.templateModel]);
        },
        disabled() {
            return this.creatingTemplate || this.newTemplate === ''
        },
        activeTemplate: {
            get() {
                return this.template;
            },
            set(template) {
                this.$emit('input', template);
            }
        },
        placeholder() {
            return this.moduleInfo.text.new_template_placeholder || this.$t('settings.email-templates.template_name');
        }
    },
    methods: {
        createTemplate() {
            if (this.creatingTemplate) {
                return;
            }

            this.creatingTemplate = true;

            const lastModel = this.model.orderBy('order', 'desc').first();
            const nextOrder = lastModel ? lastModel.order + 1 : 1;

            this.service.store({
                data: {
                    attributes: {
                        title: this.newTemplate,
                        order: nextOrder,
                    }
                },
            })
                .then(result => this.model.save(normalizeJson(result)))
                .then(result => {
                    const template = result;
                    template[this.moduleInfo.children] = [];
                    this.activeTemplate = template;
                    this.newTemplate = '';
                    this.creatingTemplate = false;
                });
        },
    }
}
</script>
